import {
	Button,
	Card, For, Grid, GridItem, Stack, Text,
} from '@chakra-ui/react';
import type { Route } from 'next';
import { Fragment } from 'react';

import { NextLinkWrapper } from '@/modules/navigation';

export const mockedJobList = [
	{
		id: 'job-1',

		companyName: 'SyncLab Co., Ltd.',
		jobTitle:    'Accounts Receivable (AR) Officer Contract 1 Year',
	},
	{
		id: 'job-2',

		companyName: 'DreamMakers Co., Ltd.',
		jobTitle:    'Senior Accounts Payable Officer',
	},
	{
		id: 'job-3',

		companyName: 'BounceBox Co., Ltd.',
		jobTitle:    'Graphic Designer',
	},
	{
		id: 'job-4',

		companyName: 'SyncLab Co., Ltd.',
		jobTitle:    'Electrical Engineer',
	},
	{
		id: 'job-5',

		companyName: 'SyncLab Co., Ltd.',
		jobTitle:    'Accounts Receivable (AR) Officer Contract 1 Year',
	},
	{
		id: 'job-6',

		companyName: 'DreamMakers Co., Ltd.',
		jobTitle:    'Senior Accounts Payable Officer',
	},
	{
		id: 'job-7',

		companyName: 'BounceBox Co., Ltd.',
		jobTitle:    'Graphic Designer',
	},
	{
		id: 'job-8',

		companyName: 'SyncLab Co., Ltd.',
		jobTitle:    'Electrical Engineer',
	},
];

export const LatestJobListScreen = () => {
	return (
		<Stack gap="md">
			<Text textStyle="h1">New Job</Text>
			<Card.Root>
				<Card.Body p={0}>
					<Grid
						css={{
							'& > *': {
								_odd: { bg: 'gray.15' },
								p:    4,
								px:   6,

								_even: {
									border:      '1px solid ',
									borderColor: 'gray.15',
								},
							},
						}}
						gap={0}
						gridTemplateColumns="300px 1fr"
					>
						<For each={mockedJobList}>
							{job => (
								<Fragment key={job.id}>
									<GridItem textStyle="bodyBold">
										{job.companyName}
									</GridItem>
									<GridItem>
										<NextLinkWrapper color="primary.100" href={`/job/${job.id}` as Route<string>}>
											{job.jobTitle}
										</NextLinkWrapper>
									</GridItem>
								</Fragment>
							)}
						</For>
					</Grid>
				</Card.Body>
			</Card.Root>
			<Button mx="auto" variant="outline" w="fit">Filtering more the search</Button>
		</Stack>
	);
};
